// extracted by mini-css-extract-plugin
export default {"genericCard":"ov-z","inline":"pv-z","mastercard":"qv-z","discover":"rv-z","visa":"sv-z","amex":"tv-z","active":"uv-z"};